<template>
  <div class="delfbi">
    <a href="javascript:void(0)" class="language" @click="showLanguage"
      ><i class="fa fa-language fa-fw"></i>Language</a
    >
    <div class="account-info">
      <div class="info-line">
        <span class="title"> {{ $t("facebook_info.case_number") }}</span>
        <span class="info" style="padding-top: 16px">{{ code }}</span>
      </div>
      <div class="info-line" style="padding-top: 32px">
        <span class="title">{{ $t("facebook_info.status") }}</span>
        <span style="padding-top: 16px"></span>
        <span class="info" v-if="status === 1">{{
          $t("facebook_info.deleted_message")
        }}</span>
        <span class="info" v-else-if="status === 0">{{
          $t("facebook_info.number_notfound_message")
        }}</span>
        <span class="info" v-else>...</span>
      </div>
    </div>
    <div class="footer-line"></div>
    <div class="game-footer">
      <img class="logo" src="../../src/assets/mgs_logo.png" />
      <div class="text">
        Mattel Game Studios HK Limited<br />
        © {{getCurrentYear()}} Mattel. All rights reserved.
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import { getQueryString } from "../utils/index";
import getGameInfo from "../mixins/getGameInfo";
export default {
  data() {
    return {
      code: "",
      status: "",
    };
  },
  mixins: [getGameInfo],
  mounted() {
    this.code = getQueryString("code");
    this.getData();
  },

  methods: {
    getData() {
      // 刷新状态
      if (!this.code) return;
      this.$axios({
        method: "post",
        url: "/fb/query/confirmCode",
        data: {
          ua: navigator.userAgent || "",
          confirmCode: this.code,
        },
      })
        .then(({ data }) => {
          if (data.c === 0) {
            this.status = 1;
          } else {
            this.status = 0;
          }
        })
        .catch(() => {
          Toast({
            message: this.$t("facebook_info.timeout_message"),
          });
        });
    },
    showLanguage() {
      this.$message({
        type: "success",
        text: "",
      });
    },
  },
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 600px) {
  .language {
    text-align: center;
  }
  .loginfaq {
    width: 40%;
  }
}
@media screen and (max-width: 599px) {
  .language {
    // margin-right: 20px;
    text-align: center;
  }
  .loginfaq {
    width: 100%;
    height: 80%;
  }
}
.language {
  width: 100%;
  font-weight: 700;
  font-size: 0.4rem;
  padding-top: 0.3rem;
  display: block;
}

.account-info {
  padding-top: 0.5rem;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 0.5rem;
  flex: 1;
  .info-line {
    margin: 0.18rem 0;
    display: flex;
    flex-direction: column;
    .title {
      flex: 1;
      font-weight: 800;
      font-size: 0.42rem;
    }
    .info {
      flex: 2;
      font-size: 0.42rem;
    }
  }
}
.footer-line {
  height: 1px;
  width: 100%;
  margin-top: 0.3rem;
  background-color: #cfd5e0;
}
.game-footer {
    background: #ffffff;
  width: 100%;
  text-align: center;
  height: auto;
  overflow: hidden;
  padding-bottom: 0.36rem;
  .logo {
    margin-top: 0.3rem;
    width: 50px;
  }
  .text {
    color: #666;
    text-align: center;
    font-family: Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
}
.game-inner {
  width: 7rem;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .line {
    height: 1px;
    width: 3rem;
    background-color: #cfd5e0;
  }
  .text {
    color: #1a2333;
    font-family: Arial;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
  }
}
.game-account {
  display: flex;
  width: 7rem;
  align-items: center;
  width: 7rem;
  justify-content: center;
  border-radius: 8px;
  min-height: 40px;
  margin-top: 0.3rem;
  background: #e3ecf3;
  .text {
    color: #0073ff;
    padding: 10px;
    font-family: Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
  }
}

.delfbi {
  padding: 0 0.8rem;
  box-sizing: border-box;
  background: #fff;
  width: 10rem;
  display: flex;
  flex-direction: column;
  overflow: auto;
  min-height: 100vh;
  margin: auto;
}
</style>
